import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarEspacios from '../../components/espacios/SidebarEspacios';
import './EspaciosGlobal.css';

const AreasEspacios = () => {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newArea, setNewArea] = useState({ nombre: '', descripcion: '' });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  
  const user = JSON.parse(localStorage.getItem('user_espacios') || '{}');
  const initial = user.nombre ? user.nombre.charAt(0).toUpperCase() : 'A';
  
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;

  useEffect(() => {
    if (!localStorage.getItem('user_espacios')) {
      navigate('/espacios/login');
      return;
    }
    fetchAreas();
  }, []);

  const fetchAreas = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/espacios/areas`, { 
        credentials: 'include',
        cache: 'no-store'
      });

      if (resp.status === 401) {
        localStorage.removeItem('user_espacios');
        navigate('/espacios/login');
        return;
      }

      if (!resp.ok) throw new Error('Error en la respuesta del servidor');

      const data = await resp.json();
      setAreas(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching areas:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateArea = async (e) => {
    e.preventDefault();
    if (!newArea.nombre) return;
    setSaving(true);
    try {
      const resp = await fetch(`${apiBase}/api/espacios/areas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newArea),
        credentials: 'include'
      });
      if (resp.ok) {
        setShowModal(false);
        setNewArea({ nombre: '', descripcion: '' });
        fetchAreas();
      }
    } catch (err) {
      console.error('Error creating area:', err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      <main className="App-main-espacios">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <div className="spinner"></div>
        </div>
      </main>
    </div>
  );

  return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      
      <main className="App-main-espacios">
        <header className="view-page-header">
          <div className="view-title-block">
            <h2>Gestión de Áreas</h2>
            <p>Directorio centralizado de infraestructura institucional</p>
          </div>
          <div className="header-actions">
            <button className="btn-high-end btn-high-end-primary" onClick={() => setShowModal(true)}>
              <i className="fa-solid fa-folder-plus"></i> Nueva Área
            </button>
            <div className="user-pill-dark">
              <div className="avatar">{initial}</div>
              <span>{user.nombre || 'Administrador'}</span>
            </div>
          </div>
        </header>

        <div className="areas-grid-premium" style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
          gap: '24px' 
        }}>
          {areas.map(area => (
            <div key={area.id} className="calendar-glass-card area-interactive-card" style={{ 
              padding: '28px', 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '16px',
              transition: 'transform 0.3s ease, border-color 0.3s ease',
              cursor: 'pointer'
            }} onClick={() => navigate(`/espacios/dashboard?areaId=${area.id}`)}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '56px', 
                  height: '56px', 
                  borderRadius: '16px', 
                  background: 'var(--esp-primary-soft)', 
                  color: 'var(--esp-primary)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  fontSize: '24px',
                  boxShadow: '0 8px 16px rgba(16, 185, 129, 0.1)'
                }}>
                  <i className="fa-solid fa-layer-group"></i>
                </div>
                <span style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase', letterSpacing: '1px' }}>
                  ID-{area.id.substring(0,6)}
                </span>
              </div>
              
              <div>
                <h3 style={{ fontSize: '20px', fontWeight: '800', margin: '0 0 8px 0', color: 'white' }}>{area.nombre}</h3>
                <p style={{ 
                  fontSize: '14px', 
                  color: 'var(--esp-text-muted)', 
                  lineHeight: '1.6',
                  display: '-webkit-box',
                  WebkitLineClamp: '3',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  margin: 0,
                  minHeight: '67px'
                }}>
                  {area.descripcion || 'Sin descripción técnica registrada para esta unidad administrativa.'}
                </p>
              </div>

              <div style={{ 
                marginTop: 'auto', 
                paddingTop: '20px', 
                borderTop: '1px solid var(--esp-border)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: 'var(--esp-primary)' }}>
                  <i className="fa-solid fa-door-open" style={{ marginRight: '8px' }}></i>
                  {area.espacios_count || 0} Espacios
                </div>
                <button className="btn-high-end" style={{ background: 'var(--esp-surface-light)', color: 'white', padding: '8px 16px' }}>
                  Gestionar <i className="fa-solid fa-chevron-right" style={{ marginLeft: '10px', fontSize: '10px' }}></i>
                </button>
              </div>
            </div>
          ))}

          {areas.length === 0 && (
            <div className="calendar-glass-card" style={{ gridColumn: '1 / -1', padding: '80px', textAlign: 'center' }}>
              <i className="fa-solid fa-folder-open" style={{ fontSize: '48px', color: 'var(--esp-text-muted)', opacity: 0.2, marginBottom: '20px' }}></i>
              <h3 style={{ color: 'var(--esp-text-muted)' }}>No hay áreas registradas</h3>
              <p style={{ color: 'var(--esp-text-muted)', marginTop: '10px' }}>Haz clic en "Nueva Área" para comenzar la configuración.</p>
            </div>
          )}
        </div>

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(10px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div className="calendar-glass-card" style={{ maxWidth: '480px', width: '90%', padding: '40px' }} onClick={e => e.stopPropagation()}>
              <div style={{ marginBottom: '32px' }}>
                <h3 style={{ fontSize: '24px', fontWeight: '800' }}>Nueva Área</h3>
                <p style={{ fontSize: '14px', color: 'var(--esp-text-muted)' }}>Defina una unidad administrativa para agrupar recintos.</p>
              </div>
              
              <form onSubmit={handleCreateArea} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Nombre del Área</label>
                  <input 
                    type="text" 
                    value={newArea.nombre}
                    onChange={e => setNewArea({...newArea, nombre: e.target.value})}
                    placeholder="Ej: Edificio Consistorial, Polideportivo..." 
                    style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }} 
                    required
                  />
                </div>
                <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Descripción</label>
                  <textarea 
                    value={newArea.descripcion}
                    onChange={e => setNewArea({...newArea, descripcion: e.target.value})}
                    placeholder="Detalles sobre la ubicación o uso general..." 
                    style={{ minHeight: '100px', borderRadius: '10px', padding: '12px', border: '1px solid var(--esp-border)', background: 'var(--esp-surface-light)', color: 'white', resize: 'vertical', outline: 'none' }}
                  ></textarea>
                </div>

                <div style={{ display: 'flex', gap: '16px', marginTop: '12px' }}>
                  <button type="button" className="btn-high-end" style={{ flex: 1, background: 'var(--esp-surface-light)', color: 'white', justifyContent: 'center' }} onClick={() => setShowModal(false)}>Cancelar</button>
                  <button type="submit" className="btn-high-end btn-high-end-primary" style={{ flex: 2, justifyContent: 'center' }} disabled={saving}>
                    {saving ? 'Guardando...' : 'Crear Área'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default AreasEspacios;
